import React, { CSSProperties } from 'react'
import { BaseButton, After, Before } from './styles'
import { Color } from '../../config/theme'

export interface Props {
  className?: string
  before?: JSX.Element
  after?: JSX.Element
  label: string | JSX.Element
  backgroundColor?: Color
  fontColor?: Color
  borderColor?: Color
  smallPadding?: boolean
  small?: boolean
  disabled?: boolean
  block?: boolean
  alignText?: 'flex-start' | 'flex-end' | 'center'
  type?: 'button' | 'submit' | 'reset'
  style?: CSSProperties
  onClick?: (evt?: any) => void
}

const Button: React.FC<Props> = ({
  before,
  after,
  label,
  disabled = false,
  type = 'button',
  backgroundColor = 'darkBlue',
  fontColor = 'white',
  borderColor = backgroundColor,
  alignText = 'center',
  smallPadding = false,
  small = false,
  block = false,
  onClick,
  className,
  style,
}) => (
  <BaseButton
    backgroundColor={backgroundColor}
    fontColor={fontColor}
    borderColor={borderColor}
    smallPadding={smallPadding}
    small={small}
    onClick={onClick}
    disabled={disabled}
    alignText={alignText}
    type={type}
    block={block}
    className={className}
    style={style}
  >
    {before && (
      <Before>
        {before}
      </Before>
    )}
    { label}
    {after && (
      <After>
        {after}
      </After>
    )}
  </BaseButton>
)

export default Button
